/**
 * novedadesConfig.js — quién puede ver el modal de Novedades (lado lectura).
 *
 * El contenido de cada versión vive en `changelog.js` con su audiencia escrita
 * a mano; QUIÉN puede abrir el modal y QUÉ versiones están publicadas lo decide
 * el superadministrador desde Panel Admin → Novedades, sin desplegar.
 *
 * `changelogParaRol` y `hayNovedadesSinVer` son síncronas y se llaman al
 * pintar, así que la configuración se cachea en localStorage y se lee de ahí.
 * `Layout` la refresca al entrar a la app (ver `novedadesService.js`);
 * `limpiarSesion` la borra al cambiar de usuario, porque depende del rol.
 *
 * Este archivo NO importa nada a propósito: `changelog.js` lo importa, y
 * cualquier import suyo que termine en el cliente de API cerraría el ciclo
 * changelog → apiClient → sesion → changelog (sesion lee STORAGE_KEY del
 * changelog al cargarse, así que el ciclo revienta con un ReferenceError).
 * Las llamadas al servidor viven en `shared/services/novedadesService.js`.
 *
 * Mientras no se haya cargado, se asume que NO se puede ver: así un residente
 * nunca alcanza a ver un aviso que no le tocaba. El superadministrador siempre
 * puede, esté como esté configurado, para poder revisar antes de publicar.
 */

export const CLAVE_CONFIG_NOVEDADES = "novedades_config";

function esSuperadmin() {
  try {
    return localStorage.getItem("is_superuser") === "true";
  } catch {
    return false;
  }
}

/** Config cacheada, o null si todavía no se cargó. */
export function configNovedades() {
  try {
    const crudo = localStorage.getItem(CLAVE_CONFIG_NOVEDADES);
    return crudo ? JSON.parse(crudo) : null;
  } catch {
    return null;
  }
}

/** Deja la config en caché para que la lean las funciones síncronas. */
export function cachearConfigNovedades(data) {
  try {
    localStorage.setItem(CLAVE_CONFIG_NOVEDADES, JSON.stringify(data));
  } catch {
    /* localStorage bloqueado (modo privado) */
  }
}

/** true si este usuario tiene habilitado el modal de Novedades. */
export function novedadesHabilitadas() {
  if (esSuperadmin()) return true;
  return configNovedades()?.puede_ver === true;
}

/** Versiones que el superadministrador todavía no publicó. */
export function versionesOcultas() {
  if (esSuperadmin()) return [];   // él las ve para poder revisarlas antes
  return configNovedades()?.versiones_ocultas || [];
}
